import AuthGateway from '../components/auth/AuthGateway'
import ForgotPassword from '../components/auth/passwords/ForgotPassword'
import SignInController from '../components/auth/SignInController'
import Redirect from '../components/Redirect'
import TfaSetupController from '../components/auth/tfa/TfaSetupController'
import InvitationController from '../components/auth/InvitationController'
import ReleaseKeyShare from '../components/auth/recovery/ReleaseKeyShare'
import ResetPassword from '../components/auth/passwords/ResetPassword'
import SingleSignOnController from '../components/auth/sso/SingleSignOnController'

export default [
  {
    path: 'auth',
    element: <Redirect route='sign-in' />,
    children: [
      {
        path: 'sign-in',
        element: <SignInController />
      },
      {
        path: 'tfa-setup',
        element: <AuthGateway />,
        children: [
          {
            path: '',
            element: <TfaSetupController />
          }
        ]
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />
      },
      {
        path: 'sso',
        element: <SingleSignOnController />
      }
    ]
  },
  {
    path: 'invitation/:token',
    element: <InvitationController />
  },
  {
    path: 'reset-password/:token',
    element: <ResetPassword />
  },
  // the address the recovery request emails carry, and the contact answering it has no session here
  {
    path: 'recoveries/:token',
    element: <ReleaseKeyShare />
  }
]
